<template>
  <v-layout row>
    <v-flex md7 lg7>
      <GrossingByLabManagers :data="grossingByLabManagersStats"></GrossingByLabManagers>
    </v-flex>
    <v-flex md5 lg5>
      <GlassesMicrotomed :data="glassesMicrotomedStats" class="ml-5"></GlassesMicrotomed>
    </v-flex>
  </v-layout>

</template>

<script>
import GrossingByLabManagers from './GrossingByLabManagers'
import GlassesMicrotomed from './GlassesMicrotomed'

export default {
  name: 'SecondScreen',
  props: {
    grossingByLabManagersStats: {
      Type: Object
    },
    glassesMicrotomedStats: {
      Type: Object
    }
  },
  components: {
    GrossingByLabManagers,
    GlassesMicrotomed
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Walldash/SecondScreen.vue